export default __webpack_public_path__ + "static/media/armin_l.7d8bad41.jpg";